export default __webpack_public_path__ + "static/media/archive-content 1.a6eb2efe.svg";